import { useResponsiveReady } from '../../hooks/use-responive-ready';

const HideMobile = ({ children }) => {
  const { isMobile } = useResponsiveReady();

  return isMobile ? null : children;
};

export default HideMobile;
